module.exports = __webpack_public_path__ + "img/change-password-image.45308465.svg";